import './arrow.css';
import IconBackground from '../iconsBackground/iconsBackground'

export default function Arrow({point, onClick}) { 

    // 180 = true 0 = false

    const pointer = point ? '180' : '0';

    const arrowCenter = point ? '12.5rem' : '-12.5rem';

    const bubble = point ? '-89.5' : '89.5';

    return (
        <div className="arrow-container" onClick={onClick}>
            <div className="arrow-bubbles" style={{ transform: `rotate(${bubble}deg) ` }}>
                <IconBackground/>
            </div>
            <div className="arrows" style={{ transform: `rotate(${pointer}deg) translateY(${arrowCenter}) translateX(-2rem)` }}>
                <svg width="61.509" height="45.365" viewBox="0 0 61.509 45.365">
                    <g id="Group_30" data-name="Group 30" transform="translate(61.509 45.365) rotate(180)">
                        <path id="Icon_material-round-arrow-right" data-name="Icon material-round-arrow-right" d="M10.811,43.493,27.185,27.119a6.3,6.3,0,0,0,0-8.914L10.811,1.831A6.355,6.355,0,0,0,0,6.319V39A6.328,6.328,0,0,0,10.811,43.493Z" transform="translate(29.034 45.365) rotate(180)" fill="#72bf72"/>
                        <rect id="Rectangle_53" data-name="Rectangle 53" width="29" height="9" rx="4.5" transform="translate(32.509 19.399)" fill="#72bf72"/>
                    </g>
                </svg>
            </div>
        </div>
    )
}
